<template>
<section class="map-container">
  <a :href="image.urlMap" rel="noopener" target="_blank">
    <figure data-parallax="0.1">
      <img v-lazy="switchImg" :alt="image.alt">
      <div
        v-lazy:background-image="switchImg"
      ></div>

      <span
        data-mouse
        data-mouse-attractionState="active"
        data-mouse-attractionVal="30"
        data-mouse-magnetism="5"
        data-hover-type="fadeout"
        data-anim="fade"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 50 62"
        >
          <path class="pin" d="M25 1.7C12.2 1.7 1.7 12.1 1.7 24.8 1.7 36.7 22.4 58.3 25 61c2.6-2.6 23.3-24.2 23.3-36.2C48.3 12.1 37.8 1.7 25 1.7z" fill="#1217ff" stroke="#1217ff"/>
        </svg>
      </span>
    </figure>
  </a>
</section>
</template>

<script>
export default {
  name: 'MapContainer',

  props: ['image'],

  computed: {
    switchImg() {
      if ((window.chrome && window.chrome.webstore) || (window.opr && window.opr.addons)) {
        return `${this.image.url}.webp`;
      }
      return `${this.image.url}.jpg`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.map-container {
  position: relative;
  width: calc(100% + 80px);
  padding: 0 0 100px 0;
  margin-left: -40px;

  figure {
    position: relative;
    width: 100%;
    margin: 0;
    padding: 0;

    overflow: hidden;

    @include aspect-ratio(2, 1);

    img {
      @include visually-hidden;
    }

    div {
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background-position: center center;
      background-repeat: no-repeat;
      background-size: 200%;

      @include mq(sm) {
        background-size: cover;
      }
    }
  }

  span {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;

    transform: translateX(-50%) translateY(-50%);
  }

  svg {
    position: relative;
    width: 35px;
    height: auto;

    @include boost-performance();

    @include mq(sm) {
      padding: 40px;
      width: 125px;
    }

    .pin {
      stroke-width: 1px;

      fill-opacity: 1;
      transition: all 0.2s cubic-bezier(.17,.67,.32,.87);

      @include mq(sm) {
        fill-opacity: 0;
      }
    }

    @at-root .pointerevents:not(.touchevents) &:hover .pin,
    .no-pointerevents.no-touchevents &:hover .pin {
      fill-opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MapContainer.vue